import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import './InfoPages.css';

function LegalPrivacy() {
  const { t } = useTranslation();
  return (
    <div className="infoPage">
      <Header />
      <div className="infoPageLayout">
        <div className="infoHero">
          <h1>{t('infoPages.legalPrivacy.title')}</h1>
          <p>{t('infoPages.legalPrivacy.description')}</p>
        </div>

        <div className="infoSection">
          <nav className="legalNav" aria-label="Legal sections">
            <a href="#terms">{t('infoPages.legalPrivacy.termsOfService')}</a>
            <a href="#privacy">{t('infoPages.legalPrivacy.privacyPolicy')}</a>
            <a href="#cookies">{t('infoPages.legalPrivacy.cookiePolicy')}</a>
          </nav>
        </div>

        <div id="terms" className="infoSection">
          <h2>{t('infoPages.legalPrivacy.termsOfService')}</h2>
          <p>{t('infoPages.legalPrivacy.termsIntro')}</p>
          <h3>1. {t('infoPages.legalPrivacy.terms1')}</h3>
          <p>{t('infoPages.legalPrivacy.terms1Desc')}</p>
          <h3>2. {t('infoPages.legalPrivacy.terms2')}</h3>
          <p>{t('infoPages.legalPrivacy.terms2Desc')}</p>
          <h3>3. {t('infoPages.legalPrivacy.terms3')}</h3>
          <p>{t('infoPages.legalPrivacy.terms3Desc')}</p>
          <h3>4. {t('infoPages.legalPrivacy.terms4')}</h3>
          <p>{t('infoPages.legalPrivacy.terms4Desc')}</p>
        </div>

        <div id="privacy" className="infoSection">
          <h2>{t('infoPages.legalPrivacy.privacyPolicy')}</h2>
          <p>{t('infoPages.legalPrivacy.privacyIntro')}</p>
          <h3>{t('infoPages.legalPrivacy.infoCollect')}</h3>
          <p>{t('infoPages.legalPrivacy.infoCollectDesc')}</p>
          <h3>{t('infoPages.legalPrivacy.howUse')}</h3>
          <p>{t('infoPages.legalPrivacy.howUseDesc')}</p>
          <h3>{t('infoPages.legalPrivacy.sharing')}</h3>
          <p>{t('infoPages.legalPrivacy.sharingDesc')}</p>
          <h3>{t('infoPages.legalPrivacy.yourRights')}</h3>
          <p>{t('infoPages.legalPrivacy.yourRightsDesc')}</p>
        </div>

        <div id="cookies" className="infoSection">
          <h2>{t('infoPages.legalPrivacy.cookiePolicy')}</h2>
          <p>{t('infoPages.legalPrivacy.cookieIntro')}</p>
          <h3>{t('infoPages.legalPrivacy.whatUse')}</h3>
          <p>{t('infoPages.legalPrivacy.whatUseDesc')}</p>
          <h3>{t('infoPages.legalPrivacy.managingCookies')}</h3>
          <p>{t('infoPages.legalPrivacy.managingCookiesDesc')}</p>
        </div>

        <div className="infoSection">
          <p>
            {t('infoPages.legalPrivacy.questionsPolicies')}{' '}
            <Link to="/contact" className="infoLink">
              {t('infoPages.legalPrivacy.contactUsLink')}
            </Link>
          </p>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default LegalPrivacy;
